const origin = window.location.origin
const isDev = process.env.NODE_ENV === 'development'

export const urlAsr = isDev ? 'https://speech-dev.nanosemantics.ai/api/asr' : `${origin}/api/asr`

export const urlTTS = isDev ? 'https://speech-dev.nanosemantics.ai/api/tts' : `${origin}/api/tts`

export const webSocketUrl = isDev
  ? 'wss://speech-dev.nanosemantics.ai:443/ws'
  : `wss://${window.location.host}/api/asr/ws`

export const urlConsole = isDev ? 'https://speech-dev.nanosemantics.ai/api/console' : `${origin}/api/console`

export const urlMedia = isDev ? 'https://speech-dev.nanosemantics.ai' : `${origin}`
